import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";
import "./ShoppingCart.css";
import { useSelector, useDispatch } from "react-redux";
import {
  removeFromCart,
  updateQuantity,
  selectCartTotalAmount,
} from "../../Features/Cart/cartSlice";

import { MdDelete, MdOutlineClose } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";


import Footer from "../Footer/Footer";
import { getStoredAuth } from "../../StoreData/authUser";
import { DeleteCart, GetBuyOrders, GetReview } from "../../Action/buy.Actions";
import { AppDispatch } from "../../App/store";
import { BuyOrders, CartItems, PriceDetailsI } from "../../Interface/Order.interface";
import { fetchStockItems } from "../../Action";
import { OnlineOrderDetail, OnlineOrderPayload, ProceedPaymentI, razorPayProcessI } from "../../Interface/Payment.interface";
import { confirmPayment, fetchPaymentData, SavePayment } from "../../Action/payment.Action";

import { loadRazorpayScript, openRazorpayCheckout } from "../../PaymentCheckout/PaymentCheckout";
import ImageWithSkeleton from "../Skeleton/ImageSkeleton";
import toast from "react-hot-toast";


// Type definitions
interface CartItem {
  productID: string;
  productName: string;
  productPrice: number;
  productReviews: string;
  frontImg: string;
  quantity: number;
}

interface CartState {
  items: CartItem[];
}

interface RootState {
  cart: CartState;
}

type TabType = "cartTab1" | "cartTab2" | "cartTab3";

const intialObjectPayment: ProceedPaymentI = {
  name: '',
  email: '',
  phoneNumber: '',
  address: '',
  amount: 0,
}

const initalPriceDetails: PriceDetailsI = {
  subtotal: 0,
  gst: 0,
  shippingCost: 0,
  total: 0,
}
// const initialOrder = {
//   online_Order_No: '',
//   online_Order_Date: new Date().toISOString().split('T')[0],
//   memberid: 0,
//   paymntType: 'UPI', // default mode
//   orderMode: 'ONLINE',
//   deliveryamt: 0,        // will be set to shipping/delivery amount
//   orderamount: 0,
//   discountamount: 0,
//   netAmount: 0,
//   totalAmount:0,
//   razer_Orderid: '',
//   onlineorderDetails: [],
// }


const ShoppingCart: React.FC = () => {
  const cartItems = useSelector((state: RootState) => state.cart.items);
  const dispatch = useDispatch<AppDispatch>();

  const [activeTab, setActiveTab] = useState<TabType>("cartTab1");
  const [shippingMethod, setShippingMethod] = useState<string>('pickup');

  const { buyDatas, successDelete } = useSelector((state: any) => state.BuyOrder)
  const { isAuthenticated } = useSelector((state: any) => state.auth)
  const { stockItems } = useSelector((state: any) => state.pos);

  const [proceedPayment, setProceedPayment] = useState<ProceedPaymentI>(intialObjectPayment)
  const [priceDetails, setPriceDetails] = useState<PriceDetailsI>(initalPriceDetails)
  // const [orderData, setOrderData] = useState<OnlineOrderPayload>(initialOrder)

  const [selectedItems, setSelectedItems] = useState<BuyOrders[]>([]);

  const navigate = useNavigate()


  useEffect(() => {
    dispatch(fetchStockItems());
  }, [dispatch]);


  useEffect(() => {
    handleOnPriceCalculation();
  }, [selectedItems, shippingMethod]);


  const handleOnPriceCalculation = () => {
    const subtotal: number = selectedItems.reduce((acc: number, item: BuyOrders) => {
      const price = parseFloat(item.SellingRate?.toString());
      return acc + price * item.productQty;
    }, 0);



    const gst = subtotal * 0.05;


    const shippingCost =
      shippingMethod === 'standard'
        ? 50
        : shippingMethod === 'express'
          ? 70
          : 0;

    const total = subtotal + gst + shippingCost;


    setPriceDetails((prev) => ({
      ...prev,
      subtotal: subtotal,
      gst: gst,
      total: total

    }))

    setProceedPayment(prev => ({
      ...prev,
      amount: Number(total),
    }));

  }






  useEffect(() => {
    const checkAuth = async () => {
      const storedAuth = getStoredAuth();

      if (storedAuth && storedAuth !== "[]") {
        try {
          const parsed = JSON.parse(storedAuth);
          const user = parsed[0];

          if (user?.mid) {
            await dispatch(GetBuyOrders(user.mid));

            setProceedPayment((prev => ({
              ...prev, name: user?.membername, email: user?.emailid
              , phoneNumber: user?.mobileno, address: user?.address

            })))




          }
        } catch (error) {
          console.error('Failed to parse stored auth:', error);
        }
      }
    };

    checkAuth();
  }, [dispatch]);


  useEffect(() => {
    console.log("Selected items:", selectedItems);
  }, [selectedItems]);



  const handleTabClick = (tab: TabType): void => {
    if (tab === "cartTab1" || cartItems.length > 0) {
      setActiveTab(tab);
    }
  };




  

  const scrollToTop = (): void => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Current Date
  const currentDate = new Date();

  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Random number
  const orderNumber: number = Math.floor(Math.random() * 100000);

  // Payment method state
  const [selectedPayment, setSelectedPayment] = useState<string>("Direct Bank Transfer");

  const handlePaymentChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setSelectedPayment(e.target.value);
  };

  const handleFormSubmit = (e: FormEvent): void => {
    e.preventDefault();
  };


  const imageData = stockItems.filter((stockItem: any) =>
    buyDatas.some((buyItem: any) => buyItem.itemid === stockItem.itemid)
  )



 


  const handleOnSaveFunction = async (orderPayload: OnlineOrderPayload) => {

    try {

      const response = await dispatch(SavePayment(orderPayload)).unwrap();
      if (response === "Success") {
        toast.success('Payment Successfully Submitted')
        setPriceDetails(initalPriceDetails)
        setSelectedItems([])
        await dispatch(GetBuyOrders(orderPayload?.memberid))

      }
      else {
        toast.error('Error in the Payment')
      }
      console.log("Order Save Response", response);
    }


    catch (error) {
      console.error('error in the payment')
    }
  }


  const handleOnSaveOrder = async (res: any, orderId: any) => {

    try {
      const mappedOrderDetails: OnlineOrderDetail[] = selectedItems.map((item: BuyOrders) => {
        const mrp = parseFloat(item.Mrprate as string);
        const selling = parseFloat(item.SellingRate as string);
        const qty = item.productQty || 1;
        const taxAmount = (selling * item.taxper) / 100;

        const orderAmount = selling * qty;
        const discount = mrp > selling ? (mrp - selling) * qty : 0;
        const netAmount = orderAmount + taxAmount;

        return {
          ordermasterid: 0,
          itemid: item.itemid,
          itemQty: qty,
          barcode: item.Barcode,
          batchno: item.batchno,
          ordermode: "ONLINE",
          itemMrp: mrp,
          itemSellingprice: selling,
          taxvalue: taxAmount,
          deliveryamt: 0,
          orderamount: orderAmount,
          discountamount: item.discountamount ?? 0,
          netorderamount: item.NetAmount ?? netAmount,
          totalAmount: Number(priceDetails.subtotal.toFixed(2))
        };
      });

      // Totals
      const totalOrderAmount = mappedOrderDetails.reduce(
        (sum, item) => sum + item.orderamount,
        0
      );
      const totalDiscount = mappedOrderDetails.reduce(
        (sum, item) => sum + item.discountamount,
        0
      );


      const totalNetAmount = mappedOrderDetails.reduce((sum, item) => {
        const net = item.netorderamount !== null
          ? item.netorderamount * item.itemQty
          : item.itemQty * item.itemSellingprice;
        return sum + net;
      }, 0);

      // const totalAmountData = mappedOrderDetails.reduce((sum, item) => {
      //   const total = item.totalAmount !== null
      //     ? item.totalAmount
      //     : item.itemQty * item.itemSellingprice;
      //   return sum + total;
      // }, 0);


      const deliveryAmount =
        shippingMethod === "standard"
          ? 50
          : shippingMethod === "express"
            ? 70
            : 0;

      const storedAuth = getStoredAuth();
      const parsed = JSON.parse(storedAuth)
      const data = parsed[0].mid


      // Prepare order data payload
      const orderPayload: OnlineOrderPayload = {
        online_Order_No: '0',
        online_Order_Date: new Date().toISOString(),
        memberid: data,
        paymntType: "UPI",
        orderMode: "ONLINE",
        deliveryamt: deliveryAmount,
        orderamount: totalOrderAmount,
        discountamount: totalDiscount,
        netorderamount: Number(priceDetails.subtotal.toFixed(2)),
        onlineorderDetails: mappedOrderDetails,
        totalAmount: Number(priceDetails.subtotal.toFixed(2)),
        razer_Orderid: orderId
      };


      handleOnSaveFunction(orderPayload)

    } catch (error) {
      console.error("Error in handleOnSaveOrder:", error);
    }
  };



 

  const handleOnSubmit = async () => {

    try {
      // Step 1: Load Razorpay script
      const isScriptLoaded = await loadRazorpayScript();
      if (!isScriptLoaded) {
        alert("Failed to load Razorpay SDK. Please check your internet.");
        return;
      }


      if (selectedItems?.length > 0) {

        const response = await dispatch(fetchPaymentData(proceedPayment)).unwrap();
        console.log('responseData', response);
        if (response?.orderId && response?.razorPayKey) {
          const res = await openRazorpayCheckout(response, proceedPayment, dispatch);
          handleOnSaveOrder(res, response?.orderId)
        } else {
          console.error("Missing required Razorpay response fields");
        }
      }
      else {
        toast.error('No Shopping Order')
      }

    } catch (error) {
      console.error("Error in ProceedPayment:", error);
    }
  };


  const handleonDelete = async (productid: number) => {
    const storedAuth = getStoredAuth();

    try {
      const parsed = JSON.parse(storedAuth);
      const user = parsed[0];

      if (user?.mid) {
        const successDeleteReview = await dispatch(DeleteCart(productid, user?.mid,))

        if (successDeleteReview) {
          toast.success('Item Deleted Successfully')
          await dispatch(GetBuyOrders(user?.mid))
        }
        else {
          toast.error('Item is not Deleted')
        }

        console.log(successDeleteReview, 'dataDelete')
      }

    }
    catch (error) {
      console.log(error, 'dataerror')
    }
  }


  return (
    <>

      <div className="shoppingCartSection">
        <h2 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <FaShoppingCart size={30} />
          Shopping Cart
        </h2>

        <div className="shoppingCartTabsContainer">
          {/* <div className={`shoppingCartTabs ${activeTab}`}>
            <button
              onClick={() => {
                handleTabClick("cartTab1");
                setPayments(false);
              }}
            >
            </button>
          </div> */}
          <div className="shoppingCartTabsContent">
            {/* tab1 */}
            {activeTab === "cartTab1" && (
              <div className="shoppingBagSection">
                <div className="shoppingBagTableSection">
                  {/* For Desktop Devices */}
                  <table className="shoppingBagTable">
                    <thead>
                      <tr>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Subtotal</th>
                        <th>Discount</th>
                        <th>NetTotal</th>
                        <th>TotalAmount</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {buyDatas.length > 0 ? (

                        buyDatas.map((item: BuyOrders) => {
                          const matchedImage = stockItems.find(
                            (stockItem: any) => stockItem.itemid === item.itemid
                          )?.FilePath;

                          return (
                            <tr key={item.itemid}>
                              <td data-label="Product">
                                <div className="shoppingBagTableImg">
                                  <Link to="/product" onClick={scrollToTop}>
                                    <ImageWithSkeleton
                                      src={
                                        matchedImage
                                          ? `data:image/jpeg;base64,${matchedImage}`
                                          : ''
                                      }
                                      alt="item"
                                    />
                                  </Link>
                                </div>
                              </td>
                              <td data-label="">
                                <div className="shoppingBagTableProductDetail">
                                  <Link to="/product" onClick={scrollToTop}>
                                    <h4>{item.itemname}</h4>
                                  </Link>
                                </div>
                              </td>
                              <td data-label="Price" style={{ textAlign: "center" }}>
                                ₹{item.SellingRate}
                              </td>
                              <td data-label="Quantity">
                                <div className="ShoppingBagTableQuantity">
                                  <button>-</button>
                                  <input
                                    type="text"
                                    min="1"
                                    max="20"
                                    value={item.productQty}
                                  />
                                </div>
                              </td>
                              <td data-label="Subtotal">
                                <p style={{ textAlign: "center", fontWeight: "500" }}>
                                  ₹{(item.productQty * Number(item.SellingRate)).toFixed(2)}
                                </p>
                              </td>
                              <td data-label="discountAmount">
                                <p style={{ textAlign: "center", fontWeight: "500" }}>
                                  ₹{item?.discountamount ? (item?.discountamount).toFixed(2) : 0.00}
                                </p>
                              </td>

                              <td data-label="NetTotal">
                                <p style={{ textAlign: "center", fontWeight: "500" }}>
                                  ₹{item?.NetAmount ? (item?.NetAmount * item.productQty).toFixed(2) : (item.productQty * Number(item.SellingRate)).toFixed(2)}
                                </p>
                              </td>

                              <td data-label="TotalAmount">
                                <p style={{ textAlign: "center", fontWeight: "500" }}>
                                  ₹{item?.totalAmount ? (item?.totalAmount * item.productQty).toFixed(2) : (item.productQty * Number(item.SellingRate)).toFixed(2)}
                                </p>
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedItems.some((i) => i.itemid === item.itemid)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedItems((prev) => [...prev, item]);
                                    } else {
                                      setSelectedItems((prev) =>
                                        prev.filter((i) => i.itemid !== item.itemid)
                                      );
                                    }
                                  }}
                                  style={{ marginBottom: '18px' }}

                                />
                              </td>
                              <td>
                                <MdDelete size={20} style={{ color: 'red', marginBottom: '15px' }} onClick={() => handleonDelete(item.itemid)} />
                              </td>

                            </tr>
                          );
                        })


                      ) : (
                        <tr>
                          <td colSpan={6}>
                            <div className="shoppingCartEmpty">
                              <span>Your cart is empty!</span>
                              <Link to="/" onClick={scrollToTop}>
                                <button>Shop Now</button>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {/* <tfoot>
                      <tr>
                        <th
                          colSpan={6}
                          className="shopCartFooter"
                          style={{
                            borderBottom: "none",
                            padding: "20px 0px",
                          }}
                        >
                          {cartItems.length > 0 && (
                            <div className="shopCartFooterContainer">
                              <form onSubmit={handleFormSubmit}>
                                <input
                                  type="text"
                                  placeholder="Coupon Code"
                                />
                                <button type="submit">Apply Coupon</button>
                              </form>
                              <button
                                onClick={handleFormSubmit}
                                className="shopCartFooterbutton"
                              >
                                Update Cart
                              </button>
                            </div>
                          )}
                        </th>
                      </tr>
                    </tfoot> */}
                  </table>
                  

                  {/* For Mobile devices */}
                  <div className="shoppingBagTableMobile">
                    {buyDatas.length > 0 ? (
                      <>
                        {buyDatas.map((item: BuyOrders) => {
                          const matchedImage = stockItems.find(
                            (stockItem: any) => stockItem.itemid === item.itemid
                          )?.FilePath;

                          return (
                            <div key={item.itemid} className="shoppingBagTableMobileItems">
                              <div className="shoppingBagTableMobileItemsImg">
                                <Link to="/product" onClick={scrollToTop}>
                                  <img
                                    src={
                                      matchedImage
                                        ? `data:image/jpeg;base64,${matchedImage}`
                                        : ''
                                    }
                                    alt="item"
                                  />
                                </Link>
                              </div>

                              <div className="shoppingBagTableMobileItemsDetail">
                                <div className="shoppingBagTableMobileItemsDetailMain">
                                  <Link to="/product" onClick={scrollToTop}>
                                    <h4>{item.itemname}</h4>
                                  </Link>

                                  <div className="shoppingBagTableMobileItemMeta">
                                    <p><strong>Price:</strong> ₹{item.SellingRate}</p>
                                    <p><strong>Quantity:</strong> {item.productQty}</p>
                                    <p><strong>Subtotal:</strong> ₹{(item.productQty * Number(item.SellingRate)).toFixed(2)}</p>
                                    <p><strong>Discount:</strong> ₹{item?.discountamount ? (item.discountamount).toFixed(2) : '0.00'}</p>
                                    <p><strong>Net Total:</strong> ₹{item?.NetAmount ? (item.NetAmount * item.productQty).toFixed(2) : (item.productQty * Number(item.SellingRate)).toFixed(2)}</p>
                                    <p><strong>Total Amount:</strong> ₹{item?.totalAmount ? (item.totalAmount * item.productQty).toFixed(2) : (item.productQty * Number(item.SellingRate)).toFixed(2)}</p>
                                  </div>

                                  <div className="shoppingBagTableMobileItemActions">
                                    <input
                                      type="checkbox"
                                      checked={selectedItems.some((i) => i.itemid === item.itemid)}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSelectedItems((prev) => [...prev, item]);
                                        } else {
                                          setSelectedItems((prev) =>
                                            prev.filter((i) => i.itemid !== item.itemid)
                                          );
                                        }
                                      }}
                                    />
                                    <MdDelete
                                      size={20}
                                      style={{ color: 'red', marginLeft: '10px' }}
                                      onClick={() => handleonDelete(item.itemid)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}

                      
                      </>
                    ) : (
                      <div className="shoppingCartEmpty">
                        <span>Your cart is empty!</span>
                        <Link to="/shop" onClick={scrollToTop}>
                          <button>Shop Now</button>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
                <div className="shoppingBagTotal">
                  <h3>Estimate Shipping & Taxes</h3>

                  {/* Estimate Form Section */}
                  <div className="estimateShipping">
                    <div>
                      <label htmlFor="country">Country</label>
                      <select id="country" name="country">
                        <option value="">Select Country</option>
                        <option value="IN">India</option>

                        {/* Add more countries as needed */}
                      </select>
                    </div>

                    <div>
                      <label htmlFor="state">State</label>
                      <select id="state" name="state">
                        <option value="">Select State</option>
                        <option value="Puducherry">Puducherry</option>
                        <option value="TamilNadu">TamilNadu</option>
                        {/* Add more states */}
                      </select>
                    </div>

                    <div>
                      <label htmlFor="zip">Zip / Postcode</label>
                      <input
                        type="text"
                        id="zip"
                        name="zip"
                        placeholder="Enter ZIP / Postcode"
                      />
                    </div>

                    <div>
                      <label htmlFor="shipment">Shipment Method</label>
                      <select
                        id="shipment"
                        name="shipment"
                        value={shippingMethod}
                        onChange={(e) => setShippingMethod(e?.target?.value)}
                      >
                        <option value="standard">Standard Shipping - ₹50.00</option>
                        <option value="express">Express Shipping - ₹70.00</option>
                        <option value="pickup">Pickup from Store - Free</option>
                      </select>
                    </div>
                  </div>

                  {/* Totals Table */}
                  <table className="shoppingBagTotalTable">
                    <tbody>
                      <tr>
                        <th>Sub-total</th>
                        <td>₹{priceDetails.subtotal.toFixed(2)}</td>
                      </tr>

                      {/* <tr>
                        <th>GST (5%)</th>
                        <td>₹{priceDetails.gst.toFixed(2)}</td>
                      </tr> */}
                      <tr>
                        <th>Total</th>
                        <td>₹{priceDetails.subtotal.toFixed(2)}</td>
                      </tr>
                    </tbody>
                  </table>


                  {/* Checkout Button */}
                  <button
                    onClick={() => {
                      handleOnSubmit()
                    }}
                  >
                    Proceed to Checkout
                  </button>
                </div>
              </div>
            )}

            {/* tab2 */}


            {/* tab3 */}

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ShoppingCart;